/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { locationSummarySchema } from './locationSummarySchema';

export const locationSyncResetResultSchema = z.object({
  changed: z.boolean(),
  get location() {
    return locationSummarySchema;
  },
  reason: z.enum(['ALREADY_SYNCED', 'NO_JIRA_IDENTITY', 'NO_SOURCE_VALUE']).nullish(),
});
